module.exports = __webpack_public_path__ + "static/media/trading-1.4338dd52.jpg";